import React, { useState } from "react";

import {

    Grid,

    Box

} from "@mui/material";

import FolderTree from "./FolderTree";

import FileList from "./FileList";

export default function KnowledgeExplorer() {

    const [

        selectedFolder,

        setSelectedFolder

    ] = useState("");
    return (

        <Box
            sx={{
                p: 2
            }}
        >

            <Grid
                container
                spacing={2}
            >

                {/* Folder Tree */}

                <Grid
                    size={{
                        xs: 12,
                        md: 4
                    }}
                >

                    <FolderTree

                        selectedFolder={selectedFolder}

                        onFolderSelect={setSelectedFolder}

                    />

                </Grid>

                {/* File List */}

                <Grid
                    size={{
                        xs: 12,
                        md: 8
                    }}
                >

                    <FileList

                        folderPath={selectedFolder}
                        onFolderSelect={setSelectedFolder}
                    />

                </Grid>

            </Grid>

        </Box>

    );
    }